import { CancellationPenalty } from "./types";

const generateCutOffPolicy = (duration: string): CancellationPenalty[] => [
    {
        type: "PERCENTAGE",
        duration,
        relativeTo: "TRAVEL_DATE",
        refundPercentage: 0,
    },
    {
        type: "PERCENTAGE",
        duration: null,
        relativeTo: "TRAVEL_DATE",
        refundPercentage: 100,
    },
];

export const NO_CANCELLATION = [];
export const DEFAULT_FREE_CANCELLATION = generateCutOffPolicy("PT24H");
